import * as React from "react";
import { connect } from "react-redux";

import * as actions from "../../actions";
import {
  EmailTagInput as EmailTagInputComponent,
  EmailTagInputProps as EmailTagInputComponentProps,
} from "../../components/EmailTagInput/EmailTagInput";
import { StoreState } from "../../reducers";
import { getWidgetFormErrors } from "../../reducers/methods";

interface EmailTagInputProps extends EmailTagInputComponentProps {
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  setWidgetFormError: typeof actions.setWidgetFormError;
  setUserInput: typeof actions.setUserInput;
}

class EmailTagInput extends React.Component<EmailTagInputProps> {
  render() {
    const { setWidgetFormError, setUserInput } = this.props;

    return (
      <EmailTagInputComponent
        {...this.props}
        onFormError={setWidgetFormError}
        onFormChange={setUserInput}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  formErrors: getWidgetFormErrors(state),
});

export default connect(mapStateToProps, {
  clearWidgetFormError: actions.clearWidgetFormError,
  setWidgetFormError: actions.setWidgetFormError,
  setUserInput: actions.setUserInput,
})(EmailTagInput);
